<template>
  <v-container fluid class="scan">
    <v-layout>
      <div class="search-scan" v-if="bookings.length === 0">
        <h1 class="over-title">
          Recherche d'un QR Code
          <v-progress-circular
            indeterminate
            color="red"
            class="mx-4"
            v-if="isLoading"
          ></v-progress-circular>
        </h1>
        <v-alert type="error" dismissible v-model="hasError">
          {{ errorMessage }}
        </v-alert>
        <qrcode-stream @detect="onDecode" class="qrcode-wrap"></qrcode-stream>
      </div>
      <div class="found-scan" v-else>
        <v-alert type="error" v-if="!isBookingToday()">
          La visite n'est pas prévue pour aujourd'hui !
        </v-alert>
        <v-alert type="error" v-if="order.status === 'qrcodeused'">
          Ce ticket a déjà été réceptionné
        </v-alert>
        <v-alert type="error" v-if="['processing', 'on-hold', 'pending'].includes(order.status)">
          Le paiement n'est pas en ordre !
        </v-alert>
        <OrderSummary :order="order" />
        <OrderProducts :order="order" :bookings="bookings" />
        <v-btn
          class="scan-accept"
          v-if="order.status === 'completed'"
          :loading="isStatusChangeLoading"
          :disabled="isStatusChangeLoading"
          color="success"
          :large="true"
          @click="changeStatus"
          >
          Réceptionner la commande
        </v-btn>
        <v-btn
          class="scan-again"
          :large="true"
          @click="reset"
          >
          Nouveau scan
        </v-btn>
        <v-snackbar
          v-model="isOrderReceived"
          color="green"
          :bottom="true"
        >
          La commande a bien été réceptionnée
          <v-btn
            dark
            text
            @click="isOrderReceived = false"
          >
            X
          </v-btn>
        </v-snackbar>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import OrderSummary from './Scan/OrderSummary'
import OrderProducts from './Scan/OrderProducts'
export default {
  name: 'Scan',
  components: {
    QrcodeStream,
    OrderSummary,
    OrderProducts
  },
  data () {
    return {
      isLoading: false,
      hasError: false,
      errorMessage: null,
      order: null,
      booking: null,
      bookings: [],
      isStatusChangeLoading: false,
      isOrderReceived: false
    }
  },
  created () {
    this.$store.dispatch('fetchBookablePersons')
    this.$store.dispatch('fetchResources')
  },
  computed: {
  },
  methods: {
    onDecode (decodedString) {
      decodedString.then((result) => {
        if (this.isBeerstoriumUrl(result.content)) {
          const pin = this.extractPinCodes(result.content)
          this.identify(pin)
        } else {
          this.hasError = true
          this.errorMessage = 'Ce QrCode n\'est pas valide'
        }
      })
      /* if (this.isBeerstoriumUrl(decodedString)) {
        const pin = this.extractPinCodes(decodedString)
        this.identify(pin)
      } else {
        this.hasError = true
        this.errorMessage = 'Ce QrCode n\'est pas valide'
      } */
    },
    isBeerstoriumUrl (url) {
      const authorisedUrl = process.env.VUE_APP_URL_CONTENT
      return authorisedUrl.split(' ').some(substring => url.includes(substring))
    },
    extractPinCodes (url) {
      const urlArray = url.split('/')
      const pins = urlArray[urlArray.length - 1]
      const orderId = pins.split('_')[1]
      const bookingIds = pins.split('_')[0].split('-')
      return { bookingIds, orderId }
    },
    async identify (pin) {
      this.isLoading = true
      try {
        const order = await this.$store.dispatch('identifyOrder', pin.orderId)
        const bookings = []
        for (let i = 0; i < pin.bookingIds.length; ++i) {
          let booking = await this.$store.dispatch('identifyBooking', pin.bookingIds[i])
          bookings.push(booking)
        }
        this.order = order
        this.bookings = bookings
        this.isLoading = false
      } catch (error) {
        if (error.response.status === 404) {
          this.isLoading = false
          this.hasError = true
          this.errorMessage = 'Commande inconnue'
        }
      }
    },
    changeStatus () {
      this.isStatusChangeLoading = true
      this.$store.dispatch('changeOrderStatus', this.order.id)
        .then(response => {
          this.isStatusChangeLoading = false
          this.order.status = 'qrcodeused'
          this.isOrderReceived = true
        })
        .catch(() => {
          this.isStatusChangeLoading = false
        })
    },
    reset () {
      this.order = null
      this.bookings = null
      this.isOrderReceived = false
    },
    isBookingToday () {
      let value = this.bookings[0].start
      let bookingDate = new Date(value * 1000).toLocaleString().split(' ')[0]
      let today = new Date().toLocaleString().split(' ')[0]
      return today === bookingDate
    }
  }
}
</script>

<style scoped lang="scss">
.scan {
  height: 100%;
  position: relative;
  .qrcode-wrap{
    height: 100%;
    .inside{
      height: 100%;
      video{
        height: 100%;;
      }
    }
  }
}
.found-scan {
  width: 100%;
}
</style>
